export default {
  SERVICE_SELECTION: 0,
  APPLET_INTRO: 1,
  UPSELL: 2,
  RECOMMENDED_APPLETS: 3,
}
